/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// Convert hex code to RGB/RGBA
export default function hexToRgb(hexCode, alpha) {
    const hex = hexCode?.replace('#', '');
    const r = parseInt(hex?.length === 3 ? hex?.slice(0, 1).repeat(2) : hex?.slice(0, 2), 16);
    const g = parseInt(hex?.length === 3 ? hex?.slice(1, 2).repeat(2) : hex?.slice(2, 4), 16);
    const b = parseInt(hex?.length === 3 ? hex?.slice(2, 3).repeat(2) : hex?.slice(4, 6), 16);
    if (alpha) {
        return `rgba(${r},${g},${b},${alpha})`;
    }
    return `rgb(${r},${g},${b})`;
}
